import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";
import { EntityType, Module } from "@/constants";

const YextService = {

  unsubscribeListingEntity: (payload: { locationId: string, entityId: string }) => requests(SERVICE_NAME.YEXT_API).log({
    module: Module.YEXT,
    entityType: EntityType.LOCATION,
    entityId: payload.locationId,
    documentId: payload.entityId,
  }).delete(
    `reselling/location/${payload.entityId}/unsubscribe?locationId=${payload.locationId}`,
  ),

  getListingEntity: (payload: { locationId: string, entityId: string }) => requests(SERVICE_NAME.YEXT_API).log({
    module: Module.YEXT,
    entityType: EntityType.LOCATION,
    entityId: payload.locationId,
    documentId: payload.entityId,
  }).get(
    `lc-listings/${payload.locationId}/${payload.entityId}`,
  ),

  getLocationEntities: (payload: { locationId: string }) => requests(SERVICE_NAME.YEXT_API).log({
    module: Module.YEXT,
    entityType: EntityType.LOCATION,
    entityId: payload.locationId,
  }).get(
    `lc-listings/${payload.locationId}/entities`,
  ),
  getCompanySubscriptions: (payload: any) =>
    requests(SERVICE_NAME.YEXT_API).get(
      `reselling/company/${payload.companyId}/subscriptions`
    ),

  disableYextForAllLocations: (payload: any) =>
    requests(SERVICE_NAME.YEXT_API).put(
      `reselling/company/${payload.companyId}`,
      {
        offeringEnabled: false
      }
    ),

  deleteOrphanYext: (payload: any) =>
    requests(SERVICE_NAME.APPENGINE_API).post(
      "yext/support/delete_orphan_yext",
      payload
    ),

  getLocationSubscriptions: (locationId: string) =>
    requests(SERVICE_NAME.YEXT_API).get(
      `reselling/location/${locationId}/subscriptions`
    ),

  getLocationPaymentStatus: (locationId: string) =>
    requests(SERVICE_NAME.YEXT_API).get(
      `reselling/location/${locationId}/status`
    ),

  getLocationConfiguration: (locationId: string) =>
    requests(SERVICE_NAME.YEXT_API).get(
      `reselling/location/${locationId}`
    ),

  getCompanyDetails: (companyId: string) =>
    requests(SERVICE_NAME.COMPANIES_API).get(
      companyId
    ),
};

export default YextService;